<template>
  <div>
    <ImgDialogHeader
      :header-txt="page.title"
      :image-url="page.active_image ? page.active_image.url : ''"
    >
      <div class="prose content" v-html="page.template.introductie"/>
    </ImgDialogHeader>

    <wave-content
      hide-header
    >
      <div class="prose content" v-html="page.template.tekst"/>
    </wave-content>

    <activities
      :filter-options="categories"
      :items="activiteiten"
      header-txt="Activiteiten"
      @category-selected="categorySelected"
    />
  </div>
</template>

<script>
import ImgDialogHeader from '~/components/headers/ImgDialogHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import Activities from '~/components/fullwidth-blocks/Activities';
import page from '~/plugins/mixins/page';
import activiteiten from '~/graphql/queries/activiteiten';
import activiteitCategories from '~/graphql/queries/activiteitCategories';

export default {
  components: {Activities, WaveContent, ImgDialogHeader},
  mixins: [page],
  data: () => ({
    activiteiten: null,
    categories: null,
  }),
  created() {
    this.getActivities();
    this.getCategories();
  },
  methods: {
    async getActivities(category = null) {
      try {
        const {data} = await this.$apollo.query({query: activiteiten, variables: {category}});
        this.activiteiten = data.activiteiten;
      } catch (e) {
        console.log(e);
      }
    },
    async getCategories() {
      try {
        const {data} = await this.$apollo.query({query: activiteitCategories});
        this.categories = data.activiteitCategories;
      } catch (e) {
        console.log(e);
      }
    },
    categorySelected(slug) {
      this.getActivities(slug);
    },
  },
};
</script>
